import { createSlice } from '@reduxjs/toolkit';

import { MapState } from '../../types';

import { SHARED_ROUTE_HISTORY_URL_PATH_NAME } from 'entities/cars';
import {
  MAP_STATE,
  MAP_NAMES,
  COST_TYPES
} from '../../constants';

import { mapLocalStorage, createRoutePoint } from '../../utils'

import { setInitializedMap } from './setInitializedMap';
import { setSelectedPoint } from './setSelectedPoint';
import { setRoutePoints } from './setRoutePoints';
import { setShowStreetView } from './setShowStreetView';
import { setFocusPoint } from './setFocusPoint';
import { setPlannedRoutes } from './setPlannedRoutes';
import { setRouteStations } from './setRouteStations';
import { setRoutePrices } from './setRoutePrices';
import { resetPlannedRoutes } from './resetPlannedRoutes';
import { setActiveCostType } from './setActiveCostType';
import { setActiveExcise } from './setActiveExcise';

const DEFAULT_MAP = MAP_NAMES.here;

const initMapType = () => {
  if (window.location.pathname.startsWith(`/${SHARED_ROUTE_HISTORY_URL_PATH_NAME}`)) {
    mapLocalStorage.updateName(DEFAULT_MAP);
    return DEFAULT_MAP;
  }

  return mapLocalStorage.getName() || DEFAULT_MAP;
};

const initialState: MapState = {
  initialized: false,
  showStreetView: false,
  name: initMapType(),
  routes: {
    filter: {
      routePoints: [createRoutePoint(), createRoutePoint()]
    },
    plannedRoutes: [],
    routeStations: [],
    routePrices: [],
    stationServicePrices: {},
    activeCostType: COST_TYPES.netto,
    activeExcise: true
  }
};

export const mapSlice = createSlice({
  name: MAP_STATE,
  initialState,
  reducers: {
    setInitializedMap,
    setSelectedPoint,
    setRoutePoints,
    setShowStreetView,
    setFocusPoint,
    resetPlannedRoutes,
    setActiveCostType,
    setActiveExcise
  },
  extraReducers: (builder) => {
    setPlannedRoutes(builder);
    setRouteStations(builder);
    setRoutePrices(builder);
  }
});

export const mapActions = mapSlice.actions;
export const mapReducer = mapSlice.reducer;
